var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{staticClass:"form-control",attrs:{"disabled":_vm.disabled,"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.onChange,"blur":_vm.onBlur}})])
}
var staticRenderFns = []

export { render, staticRenderFns }